/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminOptionDto, AdminOptionImageDto, AdminOptionRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminOptionService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminOptionService
   * @name GetOption
   * @summary Get Option by ID
   * @request GET:/v1/admin/options/{optionId}
   * @secure
   */
  getOption = (optionId: number, params: RequestParams = {}) =>
    this.http.request<AdminOptionDto, any>({
      path: `/v1/admin/options/${optionId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminOptionService
   * @name UpdateOption
   * @summary Update a Option
   * @request PUT:/v1/admin/options/{optionId}
   * @secure
   */
  updateOption = (optionId: number, data: AdminOptionRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminOptionDto, any>({
      path: `/v1/admin/options/${optionId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminOptionService
   * @name DeleteOption
   * @summary Delete a Option
   * @request DELETE:/v1/admin/options/{optionId}
   * @secure
   */
  deleteOption = (optionId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/options/${optionId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminOptionService
   * @name GetOptions
   * @summary Get Options
   * @request GET:/v1/admin/options
   * @secure
   */
  getOptions = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminOptionDto[], any>({
      path: `/v1/admin/options`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminOptionService
   * @name CreateOption
   * @summary Create a Option
   * @request POST:/v1/admin/options
   * @secure
   */
  createOption = (data: AdminOptionRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminOptionDto, any>({
      path: `/v1/admin/options`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminOptionService
   * @name GetOptionImages
   * @summary Get Images for a Option
   * @request GET:/v1/admin/options/{optionId}/images
   * @secure
   */
  getOptionImages = (
    optionId: number,
    query?: {
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 10
       */
      size?: number;
      /**
       * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @default ["seq,ASC"]
       */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminOptionImageDto[], any>({
      path: `/v1/admin/options/${optionId}/images`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminOptionService
   * @name CreateOptionImage
   * @summary Create a Image
   * @request POST:/v1/admin/options/{optionId}/images
   * @secure
   */
  createOptionImage = (
    optionId: number,
    query: {
      /** @format int32 */
      seq: number;
    },
    data: {
      /** @format binary */
      file: File;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminOptionImageDto, any>({
      path: `/v1/admin/options/${optionId}/images`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminOptionService
   * @name DeleteOptionImage
   * @summary Delete a Option Image
   * @request DELETE:/v1/admin/options/{optionId}/images/{optionImageId}
   * @secure
   */
  deleteOptionImage = (optionId: number, optionImageId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/options/${optionId}/images/${optionImageId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
}
